module.exports = __webpack_public_path__ + "static/media/9.a108c5cc.jpg";